import React from 'react';
import { animated, useSpring } from '@react-spring/web';
import { TiWarningOutline } from 'react-icons/ti';
import {
  ModalContent,
  Background,
  ModalWrapper,
  IconContainer,
  Title,
  ParagraphsContainer,
  Paragraph,
} from './styles';

export interface IProps {
  showModal: boolean;
}

const FreemiumExpiredModal = ({
  showModal,
}: IProps) => {
  const modalRef = React.useRef<HTMLDivElement>(null);

  const animation = useSpring({
    to: {
      config: {
        duration: 250,
      },
      opacity: showModal ? 1 : 0,
      transform: showModal ? 'translateY(0%)' : 'translateY(-100%)',
    },
  });

  return (
    <>
      {showModal ? (
        <Background ref={modalRef}>
          <animated.div style={animation}>
            <ModalWrapper showModal={showModal}>
              <ModalContent>
                <IconContainer>
                  <TiWarningOutline
                    size={40}
                    color="white"
                  />
                </IconContainer>

                <Title>Vagas de hoje encerradas</Title>

                <ParagraphsContainer>
                  <Paragraph>Para garantir a qualidade do atendimento de nossos treinadores, as vagas para teste gratuito estão encerradas por hoje.</Paragraph>
                  <Paragraph>Por gentileza, volte a amanhã e tente novamente.</Paragraph>
                  <Paragraph>Agradecemos sua confiança e interesse.</Paragraph>
                </ParagraphsContainer>
              </ModalContent>
            </ModalWrapper>
          </animated.div>
        </Background>
      ) : null}
    </>
  );
};

export default FreemiumExpiredModal;
